import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const Psihoterapie = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Psihoterapie</h1>
          <p style={{ fontStyle: "italic" }}>
            Intoarce-te spre tine insuti si priveste si daca inca nu te vezi
            frumos, fa cum face sculptorul unei statui care trebuie sa devina
            frumoasa: taie, ciopleste, slefuieste, curata pana statuia capata un
            chip frumos. <br></br>
            (Plotin)
          </p>
          <p>
            Psihoterapia reprezinta un proces de insotire care vizeaza omul ca
            parte a celor doua lumi carora le apartine: lumea exterioara cu
            toate provocarile ei si lumea interioara si relatia cu propria
            persoana.
          </p>
          <p>
            Acest tip de insotire te ajuta sa devii mai intelegator cu tine: vei
            intelege cat din ceea ce traiesti are legatura cu realitatea
            prezenta si cat are legatura cu trecutul si cu raspunsurile pe care
            le porti in tine.
          </p>
          <p>
            Prin psihoterapie vei putea dezvolta noi raspunsuri emotionale si
            comportamentale in acord cu nevoia ta de dezvoltare si devenire
            pentru ca scopul psihoterapiei este vindecarea prin intelegerea si
            prelucrarea suferintelor pentru ca tu sa poti SA FII si sa te te
            bucuri de viata.
          </p>
          <div class="s-bubbles">
            <div class="s-bubble">RELATIE</div>
            <div class="s-bubble">SPRIJIN</div>
            <div class="s-bubble">SUPORT</div>
            <div class="s-bubble">INTELEGERE</div>
            <div class="s-bubble">VINDECARE</div>
            <div class="s-bubble">RESPONSABILITATE</div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Psihoterapie;
